import { openBlock as c, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(r, e) {
  return c(), l("svg", o, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M11.345 2.005c-.043.004-.18.018-.303.028-2.84.256-5.501 1.788-7.187 4.144a9.9 9.9 0 0 0-1.765 4.369c-.08.549-.09.711-.09 1.456s.01.907.09 1.456c.543 3.755 3.216 6.91 6.84 8.08.65.208 1.334.351 2.112.437.303.033 1.613.033 1.916 0 1.343-.149 2.48-.48 3.603-1.053.172-.088.205-.112.182-.131a191 191 0 0 1-1.629-2.184l-1.599-2.16-2.004-2.965a284 284 0 0 0-2.017-2.964 161 161 0 0 0-.02 2.925c-.006 2.816-.008 2.93-.043 2.996a.36.36 0 0 1-.172.178c-.063.031-.117.037-.412.037h-.339l-.09-.056a.4.4 0 0 1-.13-.143l-.042-.088.004-3.92.006-3.92.06-.077a.5.5 0 0 1 .145-.12c.08-.038.112-.042.45-.042.399 0 .465.016.569.129.03.031 1.114 1.665 2.412 3.634l3.946 5.975 1.583 2.399.08-.053a10.3 10.3 0 0 0 2.055-1.802 9.95 9.95 0 0 0 2.354-5.112c.08-.549.09-.711.09-1.456s-.01-.907-.09-1.456c-.543-3.755-3.216-6.91-6.84-8.08a10.5 10.5 0 0 0-2.083-.435c-.187-.02-1.48-.041-1.642-.026m4.094 6.048c.094.047.17.137.197.231.016.05.02 1.138.016 3.587l-.006 3.515-.62-.95-.621-.95V10.93c0-1.652.008-2.58.02-2.625a.4.4 0 0 1 .193-.247c.08-.04.11-.045.416-.045.29 0 .34.004.405.04"
    }, null, -1)
  ]));
}
const s = { render: n };
export {
  s as default,
  n as render
};
